// import Login from "./components/Login";//
import { Navigate, Route, Routes } from "react-router-dom";
import Private from "./components/Private";
// import ProtectedRoute from './components/ProtectedRoute';

///componentes Edu
import Login2 from "./components/Login2"; // Mix
import Navbar from "./components/Navbar";
import PanelAdmin from "./components/paneles/PanelAdmin";
import Correo from "./components/mensajes/Correo"; //MATERIAL TABLE
import Correo2 from "./components/mensajes/Correo2";
import PanelUser from "./components/paneles/PanelUser";
import InfoUser from "./components/paneles/InfoUser";
import StockTotal from "./components/paneles/stkFisico/StockTotal";
import Soloenvases from "./components/paneles/stkFisico/Soloenvases";
import StkFisicoG from "./components/stockfisicogranel/StkFisicoG";
import StkFisico from "./components/stockfisicoenvases/StkFisico";
import GestionUsuarios from "./components/referencias-tablas/users/GestionUsuarios";
import TanquesFijos from "./components/propelente/ref-tab/tanques_fijos/TanquesFijos";
import Auditorias from "./components/auditorias/Auditorias";
import MapaVentasEnvasado from "./components/mapas/envasado/MapaVentasEnvasado";
import MapaVentasEnvasadoNuevo from "./components/mapas/envasado/MapaVentasEnvasadoNuevo";
// import Factibilidades2 from "./components/factibilidades/old/Factibilidades2";
import ApiCoboltest from "./components/tests/ApiCoboltest";

/* -------------------------------------------------------------------------------- */
//MAGALI PEREA
//GRANEL
import Clientes from "./components/referencias-tablas/clientes/abmclientes/tabla/Clientes";
import PedidosTabs from "./components/referencias-tablas/pedidos/PedidosTabs";
// import Tanques from "./components/referencias-tablas/tanques/tabs/asignado/Tanques";
import Tanques from "./components/referencias-tablas/tanques/TabsTanques";
import AprobacionCambioTitularidad from "./components/referencias-tablas/clientes/datoscliente/cambio_titularidad/AprobacionCambioTitularidad";

//PROPELENTES / GRANEL
import AddRemitos from "./components/remitos/AddRemitos.js";
import Remitos from "./components/remitos/Remitos";

//  - Factibilidades
import FactibilidadesTable from "../src/components/factibilidades/FactibilidadesTable";
import AprobarConfig from "../src/components/factibilidades/config/AprobarConfig";
//  - Facturacion
import MontosMinimosTable from "../src/components/montos_minimos_percepciones/MontosMinimosTable";
// import FacturacionEspecial from "./components/facturacion_especial/FacturacionEspecial";
import FacturacionRemitosList from "./components/facturacion_especial/FacturacionRemitosList";

import FichaCliente from "../src/components/referencias-tablas/clientes/datoscliente/FichaCliente";
import PantallaGeneral from "./components/ventas/facturacion/PantallaGeneral";
import ContainerListadoComprobantes from "./components/ventas/verComprobantes/components/ContainerListadoComprobantes.js";

// -Impuestos
import LibroIvaDigital from "./components/impuestos/libroIvaDigital/LibroIvaDigital.js";
import ArchivoDdJjIiBb from "./components/impuestos/ddjjIiBb/ArchivoDdJjIiBb.js";
import ArchivoPercIva from "./components/impuestos/percepcionIva/ArchivoPercIva.js";
import ExencionesList from "./components/impuestos/listadoExenciones/ExencionesList.js"

//VIANDAS
import SeleccionViandas from "../src/components/viandas/SeleccionViandas";
import SemanaPedidos from "../src/components/viandas/Informe/SemanaPedidos";
import SeleccionExcepcional from "../src/components/viandas/SeleccionExcepcional";
import SemanaPedidosNetizar from "../src/components/viandas/Informe/SemanaPedidosNetizar";
import AltaViandas from "./components/viandas/AltaViandas";
import Resumen from "./components/viandas/Resumen";
import FormResumenXFecha from "./components/viandas/Informe/FormResumenXFecha";
import FormResumenXEmpleado from "./components/viandas/Informe/FormResumenXEmpleado";
import NuevoPedido from "./components/viandas/NuevoPedido";

//PROPELENTE
//import Entradas_salidas from '../src/components/propelente/ref-tab/entradas_salidas/Entradas_salidas'
//import Entradas_salidas from './components/propelente/ref-tab/entradas_salidas_NOUSAR/Entradas_salidas'
import Registros from "../src/components/propelente/ref-tab/entradas_salidas/Registros";
import Scada from "../src/components/paneles/stkFisico/Scada_propelentes";

//Varios
import MapTests from "./MapsTest";

//ventas
import AddComprobante from "./components/ventas/facturacion/AddComprobante";

/* -------------------------------------------------------------------------------- */

//Componentes GUILLE S
import TablaAnalisis from "./components/propelente/ref-tab/analisis_propelentes/TablaAnalisis";
import MetodosPropelentes from "./components/propelente/ref-tab/propelentes_metodos/MetodosPropelentes";
import ComponentesPropelentes from "./components/propelente/ref-tab/propelentes_componentes/ComponentesPropelentes";
import ComponentesProductos from "./components/propelente/ref-tab/componentes_productos/ComponentesProductos";
import CompuestosPropelentes from "./components/propelente/ref-tab/propelentes_compuestos/CompuestosPropelentes";
import ProductosPropelentes from "./components/propelente/ref-tab/propelentes_productos/ProductosPropelentes";
import EnsayoItems from "./components/propelente/ref-tab/ensayo_items/EnsayoItems";
import Sectores from "./components/auditorias/Sectores";
// Panel de Control (Sector Envasado)
import PanelDeControl from "./components/gestion_envasado/PanelDeControl";

// Revision Vehiculos
import VehiculosRevision from "./components/revision_vehiculos/panel_revision_vehiculos/VehiculosRevision";
import TareasTipoVehiculos from "./components/revision_vehiculos/tareas_tipo_vehiculos/TareasTipoVehiculos";
import FrecuenciaKilometros from "./components/revision_vehiculos/frecuencias_tareas_vehiculos/FrecuenciaKilometros";
import PatentesObservaciones from "./components/revision_vehiculos/observaciones_vehiculos/PatentesObservaciones";
import PanelMantenimiento from "./components/revision_vehiculos/panel_mantenimiento/PanelMantenimiento";

import TiposVehiculos from "./components/referencias-tablas/vehiculos/tipos_vehiculos/TiposVehiculos.js";

// Componentes joaquin
import Certificaciones from "./components/granel/certificaciones/Certificaciones";
// import { ProveedoresIndex } from "./components/proveedores/v2/Proveedoresindex";
// import { ProveedoresForm } from "./components/proveedores/v2/ProveedoresForm";
// import { VerProveedor } from "./components/proveedores/v2/VerProveedor";
// import { ImputacionesIndex } from "./components/proveedores/v2/Imputaciones";
// import CondicionIIBB from "./components/proveedores/v2/CondicionIIBB";
// import Documentacion from "./components/proveedores/v2/Documentacion";
import Listado from "./components/proveedores/nueva_version/listado_proveedores/Listado.js";
import AltaProveedores from "./components/proveedores/alta_proveedores/AltaProveedores";
import CorreosAltaProveedores from "./components/proveedores/alta_proveedores/CorreosAltaProveedores";
import Listados_pendientes from "./components/proveedores/nueva_version/revision/Listados_pendientes.js";
import PagoProveedores from "./components/proveedores/pago_proveedores/PagoProveedores";
import FlujoImportacionArca from "./components/proveedores/pago_proveedores/FlujoImportacionArca";
import OrdenPagoProveedor from "./components/proveedores/pago_proveedores/OrdenPagoProveedor";
import ListadoOrdenesPago from "./components/proveedores/pago_proveedores/ListadoOrdenesPago";
import DetalleOrdenPago from "./components/proveedores/pago_proveedores/DetalleOrdenPago";
import DetalleLoteOrdenPago from "./components/proveedores/pago_proveedores/DetalleLoteOrdenPago";
import EditarOrdenPagoPendiente from "./components/proveedores/pago_proveedores/EditarOrdenPagoPendiente";
import PaginaEcheq from "./components/proveedores/cheques_proveedores/PaginaEcheq";
import ListadoChequesFisicos from "./components/proveedores/cheques_fisicos/ListadoChequesFisicos";
import ListadoListaNegra from "./components/proveedores/cheques_lista_negra/ListadoListaNegra";
import PagosNoProveedorPage from "./components/pagos/pagos_no_proveedor/PagosNoProveedorPage";

// import AddPeqProveedor from "./components/proveedores/nuevo/AddPeqProveedor.js";
import TabGestiones from "./components/granel/gestiones/TabGestiones";
import TablaFacturas from "./components/ordenpago/pages/facturas/TablaFacturas";
// import Archivo_Afip from "./components/proveedores/Afip";
import Padrones from "./components/referencias-tablas/padrones_copy/Padrones";
import MantenimientoWrapper from "./components/mant_plantas/components/wrapper-main";
import EquipmentDocumentationContainer from "./components/mant_plantas/components/equipos/v2/documents/documentacion-container";
import MatafuegosIndex from "./components/mant_plantas/components/matafuegos/MatafuegosIndex";
import TablaSuscripciones from "./components/referencias-tablas/subscripciones/TablaSuscripciones";
//Componentes Dai
import PedidosFacturas from "./components/granel/facturar/PedidosFacturas";
import Rrhh_cumpleanios from "./components/rrhh_cumpleanios/Rrhh_cumpleanios";

//Componentes Romaneo
import Romaneo_fabricantes from "./components/romaneo/fabricantes/Romaneo_fabricantes";
import Romaneo_tipos_envases from "./components/romaneo/tipos_envases/Romaneo_tipos_envases";
import Romaneo_pertenecias from "./components/romaneo/leyendas_fabricantes/Romaneo_pertenencias";
import Romaneo_reparaciones from "./components/romaneo/reparaciones/Romaneo_reparaciones";
import Romaneo_motivos from "./components/romaneo/motivos_baja/Romaneo_motivos";
import Romaneo_envases_tab from "./components/romaneo/listas_y_habilitacion_destruccion/Romaneo_envases_tab";
import Romaneo_firmas from "./components/romaneo/firmas/Romaneo_firmas";
import Romaneo_M_envases_carga from "./components/romaneo/mobile/Romaneo_M_envases_carga";

//Componentes Stock
import Familias_lista from "./components/stock_almacen/Familias_lista";
import Articulos_cargas from "./components/stock_almacen/Articulos_cargas";
import Almacenes_cargas from "./components/stock_almacen/Almacenes_cargas";
import Sucursales_cargas from "./components/stock_almacen/Sucursales_cargas";
import Motivos_salida from "./components/stock_almacen/Motivos_salida";
import Lista_articulos from "./components/stock_almacen/Lista_articulos";
import Articulos_salidas from "./components/stock_almacen/Articulos_salidas";
import Articulos_autorizados from "./components/stock_almacen/Articulos_autorizados";
import Articulos_autorizacion_transf from "./components/stock_almacen/Articulos_autorizacion_transf";
import Stock_por_sucursales from "./components/stock_almacen/Stock_por_sucursales";
import Email_delegar_aceptar from "./components/auditorias/Email_delegar_aceptar";
import Email_delegar_rechazar from "./components/auditorias/Email_delegar_rechazar";
import Autorizar_modificaciones from "./components/stock_almacen/Autorizar_modificaciones";
import Rrhh_stock from "./components/stock_almacen/rrhh/Rrhh_stock";
import Historial_fichas from "./components/stock_almacen/rrhh/Historial_fichas";
import Automotores_stock from "./components/stock_almacen/automotores/Automotores_stock";
import Inventario_vehiculo from "./components/stock_almacen/automotores/Inventario_vehiculo";
import HistorialVehiculo from "./components/stock_almacen/automotores/HistorialVehiculo";
import Inventario_conjunto from "./components/stock_almacen/automotores/Inventario_conjunto";
import Seguimiento from "./components/stock_almacen/seguimiento/Seguimiento";
import PosicionesNeumaticos from "./components/stock_almacen/automotores/PosicionesNeumaticos";
import Prendas_rrhh from "./components/stock_almacen/prendas/Prendas_rrhh";
import Talles_prendas from "./components/stock_almacen/prendas/Talles_prendas";
import Stock_empleados from "./components/stock_almacen/empleados/Stock_empleados";

// tractores tanques jaulas
import VehiculosTanques from "./components/stock_almacen/vehiculosTanques/VehiculosTanques";

//componentes reclamos
import Motivos_emergencia from "./components/granel/reclamos/motivos_emergencia/Motivos_emergencia.js";
import TabReclamos from "./components/granel/reclamos/TabReclamos";
import Bancos from "./components/referencias-tablas/bancos/Bancos";
import Reclamos_config from "./components/granel/reclamos/Reclamos_config";
import Estadisticas_reclamos from "./components/granel/reclamos/estadisticas_reclamos/Estadisticas_reclamos";
import Estadisticas_instalacion from "./components/granel/reclamos/estadisticas_instalacion/Estadisticas_instalacion";
import Estadisticas_desconexion from "./components/granel/reclamos/estadisticas_desconexion/Estadisticas_desconexion";
// import TabInstalaciones from "./components/granel/reclamos/instalaciones/TabInstalaciones.js";
import Tab_instalaciones from "./components/granel/reclamos/instalaciones2/Tab_instalaciones.js";
import Estadisticas_reemplazo from "./components/granel/reclamos/estadisticas_reemplazo/Estadisticas_reemplazo";
import Tab_desconexiones from "./components/granel/reclamos/desconexiones/Tab_desconexiones.js";

// componentes gestion crediticia
import GestionCrediticia from "./components/factibilidades/gestion-crediticia/GestionCrediticia";

// solicitudes abastecimiento
import SolicitudSucursal from "./components/solicitudes_abastecimiento/SolicitudSucursal";
import MatrizDobleEntrada from "./components/solicitudes_abastecimiento/MatrizDobleEntrada";
import PedidosProveedores from "./components/solicitudes_abastecimiento/PedidosProveedores";
import Proveedores_abastecimiento from "./components/solicitudes_abastecimiento/Proveedores_abastecimiento";
import Viajes_abastecimiento from "./components/solicitudes_abastecimiento/Viajes_abastecimiento";
import Sucursal_viajes from "./components/solicitudes_abastecimiento/Sucursal_viajes";
import Transportistas from "./components/solicitudes_abastecimiento/Transportistas";
import Viaje_arrastrable from "./components/solicitudes_abastecimiento/arrastrable/Viaje_arrastrable";
// import Viajes_abastecimiento from "./components/solicitudes_abastecimiento/Viajes/ViajesAbastecimiento";

// reguladores
import Reguladores from "./components/reguladores/Reguladores";

//Evaluacion comerciales
import EvaluacionComercial from "./components/evaluacionComerciales/evaluacion_step/EvaluacionComercial";
import CheckList_rrhh from "./components/evaluacionComerciales/checkList_RRHH/CheckList_rrhh";
import Objetivos from "./components/evaluacionComerciales/Objetivos";
import Items_comerciales from "./components/evaluacionComerciales/Items/Items_comerciales";
import Panelrrhh from "./components/evaluacionComerciales/vista_rrhh/Panelrrhh";
import Config_evaluacion from "./components/evaluacionComerciales/config/Config_evaluacion";
import Eleccion_sucursal from "./components/evaluacionComerciales/evaluacion_step/Eleccion_sucursal";
import Montos from "./components/evaluacionComerciales/AgregarMontos/Montos";
import CheckList from "./components/evaluacionComerciales/checklist/CheckList";
import Resultados_checklist from "./components/evaluacionComerciales/checklist/Resultados_checklist";
import Tabla_check from "./components/evaluacionComerciales/checklist/Tabla_check";
import Tab_checklistResultados from "./components/evaluacionComerciales/checklist/Tab_checklistResultados";
import Periodos from "./components/referencias-tablas/periodo_contable/Periodos";
import EstadisticaCheck from "./components/evaluacionComerciales/TablaEstadisticaCheck/EstadisticaCheck";
import VehiculosInactividad from "./components/evaluacionComerciales/TablaEstadisticaCheck/VehiculosInactividad";
import ResumenVehiculos from "./components/evaluacionComerciales/TablaEstadisticaCheck/ResumenVehiculos";

//punto de venta
import Punto_venta from "./components/granel/punto_venta/Punto_venta";

// VEHICULOS
import Marcas from "./components/vehiculos_nuevo/Marcas";

// Mqtt Test
import MqttTest from "./components/tests/MqttTest";
import PanelControlGranel from "./components/paneles/PanelControlGranel";

//knd
import Productos from "./components/referencias-tablas/productos/Productos";
import Tablistado from "./components/compras/ordencompra/autorizar_ordenes/Tablistado";
import VistaJefeDePlanta from "./components/compras/requerimientos/aprobar_requerimientos/VistaJefeDePlanta";
// import AutorizacionCompras from "./components/compras/AutorizacionCompras/AddOrdenes/AutorizacionCompras";
import Requerimientos_materiales from "./components/compras/requerimientos/ver_requerimientos/lista_requerimientos/Requerimientos_materiales";
import Choferes from "./components/referencias-tablas/choferes/Choferes";
import Comerciales from "./components/granel/comerciales/Comerciales";
import Contratos from "./components/granel/contratos/Contratos";
import Gestiones from "./components/granel/gestiones/Gestiones";
import Localidades from "./components/referencias-tablas/localidades/Localidades";
import Repartos from "./components/granel/repartos/Repartos";
import Certificadoras from "./components/granel/certificadoras/Certificadoras";
import Direcciones from "./components/granel/direcciones_entrega/Direcciones";
import Fabricantes from "./components/granel/fabricantes/Fabricantes";
import Rutas from "./components/granel/rutas/Rutas";
import Segmentos from "./components/granel/segmentos/Segmentos";
import Subsegmentos from "./components/granel/subsegmentos/Subsegmentos";
import Supervisores from "./components/granel/supervisores/Supervisores";
import Vehiculos from "./components/referencias-tablas/vehiculos/Vehiculos";
import TabAutorizaciones from "./components/compras/AutorizacionCompras/TabAutorizaciones";
import Rendiciones from "./components/finanzas/Rendiciones";
import Comprobantes from "./components/compras/comprobantes/Comprobantes";
import IngresoFacturasBanco from "./components/banco/IngresoFacturasBanco";
import RepartosFinalizados from "./components/granel/repartos/repartosfinalizados/RepartosFinalizados";
import ListaFacturasSucursal from "./components/granel/repartos/repartosFinalizadosSucursal/ListaFacturasSucursal";
import CorreosFallidos from "./components/correosFallidos/CorreosFallidos";
import Lista_precios, {
  Lista_preciosConsulta,
} from "./components/lista_precios/granel/lista_precios/Lista_precios";
import Lista_preciosEspeciales from "./components/lista_precios/granel/preciosEspeciales/Lista_preciosEspeciales";
import ListaRepartosSucursal from "./components/granel/repartos/repartosFinalizadosSucursal/ListaRepartosSucursal";
import AutorizantesTabla from "./components/compras/AutorizantesTabla";
import Requerimientos_rechazados from "./components/compras/requerimientos/historial_rechazados/Requerimientos_rechazados";
import Historial from "./components/compras/ordencompra/historial/Historial.js";
import { FiltrosProvider } from "./components/compras/AutorizacionCompras/AddOrdenes/context/FiltrosContext.js";
// GRUAS
import RepartosGruas from "./components/granel/repartos_gruas/RepartosGruas.js";

//tanque rehabilitacion
import Tanque_rehab from "./components/tanques_rehab_serv_tarea/Tanque_rehab";
import VencimientosTanques from "./components/tanques_rehab_serv_tarea/VencimientosTanques";
import Tanque_grupos from "./components/tanques_rehab_serv_tarea/Tanque_grupos";
import TablaPertenencias from "./components/tanques_rehab_serv_tarea/TablaPertenencias";
import Tanque_proveedor from "./components/tanques_rehab_serv_tarea/Tanque_proveedor";

// checklist seguridad e higiene
import Checklist_seg_hig from "./components/seguridad_e_higiene/Checklist_seg_hig";
import ChecklistHS from "./components/seguridad_e_higiene/Checklist/ChecklistHS";
import PanelControl from "./components/seguridad_e_higiene/Panel/PanelControl";
import TablaChecklistSH from "./components/seguridad_e_higiene/Estadistica/TablaChecklistSH";

// Tabla de sucursales

//Envasado
import TablaLista from "./components/envasados/listaPrecios/TablaLista";
import ClientesEnvasado from "./components/envasados/clientesEnvasado/ClientesEnvasado";
import PedidosEnvasado from "./components/envasados/pedidosEnvasado/PedidosEnvasado";
import TabPedidos from "./components/envasados/pedidosEnvasado/TabPedidos";
import VistaPedidosEnvasado from "./components/envasados/pedidosEnvasado/VistaPedidosSimple/VistaPedidosEnvasado.js";
import ProductoEnvasado from "./components/envasados/productosEnvasado/ProductoEnvasado";
import GeoZonas from "./components/envasados/GeoCerca/GeoZonas";
import GruposGeograficos from "./components/envasados/GeoCerca/GruposGeograficos/GruposGeograficos";
import Rendiciones_envasados from "./components/envasados/rendiciones/Rendiciones_envasados";
import { FechaProviderPedidos } from "./components/envasados/pedidosEnvasado/context/FechaContext";
import HistorialFacturados from "./components/envasados/facturados/HistorialFacturados";
import TodosPedidos from "./components/envasados/todosPedidos/TodosPedidos";
import VerFacturaEnvasado from "./components/envasados/facturados/verFactura/VerFacturaEnvasado";
import MapaPedidos from "./components/envasados/pedidosEnvasado/MapaPedidos/MapaPedidos";
import TablaRangoPrecios from "./components/envasados/rangoPrecios/TablaRangoPrecios";
import PreciosCategorias from "./components/envasados/preciosCategorias/PreciosCategorias";
import HojaDeRuta from "./components/envasados/hojaRuta/HojaDeRuta.js";
import ClientesRuta from "./components/envasados/hojaRuta/Adheridos/ClientesRuta.js";
import MotivosNoCompra from "./components/envasados/motivosNoCompra/MotivosNoCompra.js";
import PredeterminadosSisven from "./components/envasados/predeterminadosSisven/PredeterminadosSisven.js";
import UsosEnvasado from "./components/envasados/usos/UsosEnvasado.js";
import TiposClientesEnvasado from "./components/envasados/tiposClientes/TiposClientesEnvasado.js";
import ListaPreciosEspeciales from "./components/envasados/listaPreciosEspeciales/ListaPreciosEspeciales.js";
import MotivosRechazo from "./components/envasados/motivosRechazo/MotivosRechazo.js";
import EntregaConRemito from "./components/envasados/EntregaConRemito/EntregaConRemito.js";
import ClientesAsociados from "./components/envasados/EntregaConRemito/clientesAsociados/ClientesAsociados.js";
import PanelResumenRemitos from "./components/envasados/EntregaConRemito/resumenFacturas/PanelResumenRemitos.js";
import EnvasadoTalonarios from "./components/envasados/talonarios/EnvasadoTalonarios.js";
import CsvQR from "./components/envasados/csvQR/CsvQR.js";
import SucursalesHabilitadas from "./components/envasados/rendicionesExtendidasHabilitadas/SucursalesHabilitadas.js";
import PantallaPrincipalPedidos from "./components/envasados/pedidosEnvasado/PantallaPedidos/PantallaPrincipalPedidos.js";
import PedidosStandBy from "./components/envasados/pedidosStandBy/PedidosStandBy.js";
import SucursalesMercadoLibre from "./components/envasados/sucursalesMercadoLibre/SucursalesMercadoLibre.js";
import ResumenSucursal from "./components/envasados/resumenSucursal/ResumenSucursal.js";
import ResumenCuentaCorriente from "./components/envasados/resumenCuentaCorriente/ResumenCuentaCorriente.js";
import FiltrarMedios from "./components/envasados/filtrosMedios/FiltrarMedios.js";
import Terminales from "./components/envasados/terminales/Terminales.js";
import PosnetsChoferes from "./components/envasados/posnetsChoferes/PosnetsChoferes.js";
import ListadoClientes from "./components/envasados/listadoClientes/ListadoClientes.js";
import RemitosFacturados from "./components/envasados/EntregaConRemito/facturados/RemitosFacturados.js";
import SubidaArchivoSimple from "./components/envasados/subidaArchivos/SubidaArchivoSimple.js";
import PagosEnsadoReporte from "./components/envasados/listados_especiales/PagosEnvasadoReporte.jsx";
import Sucursales from "./components/referencias-tablas/sucursales/Sucursales";

// Tabla de facturas
import Facturas from "./components/referencias-tablas/facturasParametros/Facturas";

//stock de reguladores
import Tab_reguladores from "./components/reguladores_stock/abm/Tab_reguladores";
import Reguladores_abm from "./components/reguladores_stock/abm/Reguladores_abm";
import Reguladores_caudal from "./components/reguladores_stock/caudal/Reguladores_caudal";
import Reguladores_presion_eys from "./components/reguladores_stock/presion/Reguladores_presion_eys";
import Reguladores_marcas from "./components/reguladores_stock/marcas/Reguladores_marcas";

import Telemetria from "./components/telemetria/Telemetria";
import sp_puestos from "./components/solicitud_de_personal/puestos/Puestos";
import sp_solicitudes from "./components/solicitud_de_personal/solicitudDePersonal/SolicitudDePersonal";
import sp_mails from "./components/solicitud_de_personal/mails/Mails";
import sp_motivos from "./components/solicitud_de_personal/motivos/MotivosTabla";
import EvaluacionById from "./components/solicitud_de_personal/evaluacionesMedicas/EvaluacionById";
import sp_motivos_desplegables from "./components/solicitud_de_personal/motivosDesplegables/MotivosDesplegables";
import SpProximasEntrevistas from "./components/solicitud_de_personal/entrevistas/ProximasEntrevistas";

// Estadisticas Envasados (Nico)
import DatosSucursal from "./components/estadisticasEnvasados/DatosSucursal";
import DetalleDatos from "./components/estadisticasEnvasados/vistaDatos/DetalleDatos";
import ListaChoferes from "./components/estadisticasEnvasados/choferes/ListaChoferes";
import ListaMoviles from "./components/estadisticasEnvasados/moviles/ListaMoviles";
import DatosMoviles from "./components/estadisticasEnvasados/moviles/DatosMoviles";
import DatosChoferes from "./components/estadisticasEnvasados/choferes/DatosChoferes";
import DatosSucursalAogas from "./components/estadisticasEnvasados/estadisticasAogas/DatosSucursalAogas";
import DetalleDatosAogas from "./components/estadisticasEnvasados/estadisticasAogas/vistaDatos/DetalleDatosAogas";
import ListaChoferesAogas from "./components/estadisticasEnvasados/estadisticasAogas/choferes/ListaChoferesAogas";
import ListaMovilesAogas from "./components/estadisticasEnvasados/estadisticasAogas/moviles/ListaMovilesAogas";
import DatosMovilesAogas from "./components/estadisticasEnvasados/estadisticasAogas/moviles/DatosMovilesAogas";
import DatosChoferesAogas from "./components/estadisticasEnvasados/estadisticasAogas/choferes/DatosChoferesAogas";
import SucursalesHipergas from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/SucursalesHipergas";
import RankingFacturas from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/rankingFacturas/RankingFacturas";
import VerFactura from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/verFactura/VerFactura";
import MovilesSucursal from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/moviles/MovilesSucursal";
import PanelSucursal from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/panelDatos/PanelSucursal";
import ChoferesSucursal from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/choferes/ChoferesSucursal";
import RankingFacturasPropano from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/rankingFacturas/RankingFacturasPropano";
import RankingFacturasChofer from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/choferes/facturasChofer/RankingFacturasChofer";
import RankingChoferPropano from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/choferes/facturasChofer/RankingChoferPropano";
import RankingFacturasMovil from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/moviles/facturasMovil/RankingFacturasMovil";
import RankingMovilPropano from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/moviles/facturasMovil/RankingMovilPropano";
import PanelChofer from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/choferes/PanelChofer/PanelChofer";
import PanelMovil from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/moviles/PanelMovil/PanelMovil";
import FacturacionSucursal from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/facturacionSucursal/FacturacionSucursal";
import FacturacionChofer from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/choferes/facturacionChofer/FacturacionChofer";
import FacturacionMovil from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/moviles/facturacionMovil/FacturacionMovil";
import InfoGlobal from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/InfoGlobal/InfoGlobal";
import { FechaProvider } from "./components/estadisticasEnvasados/context/FechaContext";
import RankingVulnera from "./components/estadisticasEnvasados/hipergas/pantallaSucursales/rankingVulnerabilidad/RankingVulnera";

import Cargarmenu from "./components/viandas2/menu/Cargarmenu";
import Selecionarmenu from "./components/viandas2/seccionarmenu/Selecionarmenu";
import Selectviandas from "./components/viandas2/seccionarmenu/SeleccionarViandasV2";
import MenuSemanal from "./components/viandas2/seccionarmenu/MostrarMenuSemanal";
import SeleccionarViandasEnLaMismaSemana from "./components/viandas2/seccionarmenu/SeleccionarViandasEnLaMismaSemana.js";

//import SeleccionarViandasEnLaMismaSemana from "./components/viandas2/seccionarmenu/SeleccionarViandasEnLaMismaSemana";
// import Selectviandas from "./components/viandas2/seccionarmenu/Selectviandas";
import Resumenxempleado from "./components/viandas2/resumen/Resumenxempleado";
import GenerarExcel from "./components/viandas2/generarExcel/GenerarExcel";
import Etiquetas from "./components/viandas2/generar/Etiquetas";
import Reporte from "./components/viandas2/generar/Reporte";
// import Selecinvitado from "./components/viandas2/invitados/Selecinvitado";
import UsersSinPedir from "./components/viandas2/userSinPedir/UsersSinPedir.js";
//import ElegirLasViandas from "./components/viandas2/seccionarmenu/ElegirLasViandas";
//import Tablaresumen from "./components/viandas2/resumen/Tablaresumen";

// Viandas v2 (API /api/viandas2)
import MisViandasPage from "./components/viandasV2/empleado/pages/MisViandasPage";
import ViandasRRHHPage from "./components/viandasV2/rrhh/pages/ViandasRRHHPage";

/* ****************************************************************************************************************************************** */

// Reporte Combustibles
import ReporteCombustibles from "./components/reporte_combustibles/ReporteGeneral";
import ProveedoresCombustible from "./components/reporte_combustibles/proveedores/ProveedoresCombustible";
import ProductosReporte from "./components/reporte_combustibles/productos_reporte/ProductosReporte";
import TablaPedidoSemana from "./components/viandas2/resumen/TablaPedidoSemana";
import AnomaliasReportes from "./components/reporte_combustibles/menu_anomalias/AnomaliasReportes";

//buscador de facturas con información básica
import Buscadorfacturas from "./components/facturacion/Buscadorfacturas";

//Expo empleos

import ApplicantsView from "./components/expoEmpleoVista/VerCandidatos";
import Evepanelctrl from "./components/logeventos/Evepanelctrl";
import EstadisticaStockEnvases from "./components/paneles/estadisticaStock/EstadisticaStockEnvases";
import OrderConfirmationScreen from "./components/viandas2/seccionarmenu/OrderConfirmationScreen";

//Validar el acceso a planta de choferes-tanques-camiones
import accesoPlanta from "./components/acceso_planta/Index";

//Gestion de vacaciones de empleados => Nacho
import vacaciones from "./components/vacations/index/Index.js";
import vacacionesRechazadas from "./components/vacations/dataTable/DataTableRejected.js";
//ruta para ir dirtectamente al componente desde el formulario de vehiculos
import Addchofer from "./components/referencias-tablas/choferes/AddChofer.js";
// fichadas personal
import PanelSucursales from "./components/controlhorario/PanelSucursales.js";
//WhatsAppBot
import WaMenusWithSnacks from "./components/wa/WAMenusWithSnacks.js";
import WaTareasList from "./components/wa/WATareasList.js";
//WhatsAppBot gastos combustibles
import AutGastosCombustibleList from "./components/bot_gastos_combustible/AutGastosCombustibleList.jsx";
//RRHH2 TODO EN MAYS - Legajos
import EmpleadosPage from "./components/RRHH2/features/legajos/pages/EmpleadosPage.jsx";
import CreatedSuccessPage from "./components/RRHH2/features/legajos/pages/CreatedSuccessPage.jsx";
import LegajosWrapper from "./components/RRHH2/features/legajos/pages/LegajosWrapper.jsx";
import ConveniosPage from "./components/RRHH2/features/legajos/components/crud-convenios/ConveniosPage.jsx";
import CategoriasPage from "./components/RRHH2/features/legajos/components/crud-categorias/CategoriasPage.jsx";
import TareasPage from "./components/RRHH2/features/legajos/components/crud-tareas/TareasPage.jsx";
import OSPage from "./components/RRHH2/features/legajos/components/crud-obras-sociales/OSPage.jsx";
// Componente de Vehículos
import ComponentesVehiculos from "./components/referencias-tablas/vehiculos/componentes/ComponentesVehiculos.js";

// Componentes Canje de Envases
import CanjeRegistro from "./components/canjes/CanjeRegistro";
import CanjeResumen from "./components/canjes/CanjeResumen";
import CanjeResumenPorEmpresa from "./components/canjes/CanjeResumenPorEmpresa";
import CargaPadronContribuyentes from "./components/proveedores/nueva_version/pequeños_proveedores/carga_padron/CargaPadronContribuyentes";
import AddPeqProveedor from "./components/proveedores/nueva_version/pequeños_proveedores/abm/AddPeqProveedor.js";

import FactibilidadContainer from "./components/factibilidades/formularios/finalizacioncarga/FactibilidadContainer.js";

import recibosPendientes from "./components/referencias-tablas/clientes/datoscliente/cuentacorriente/config/tablaRecibosPendientes/RecibosPendientes.jsx";
import TablaChoferes from "./components/referencias-tablas/choferes/TablaChoferes.jsx";
import ConfiguracionesIIBB from "./components/ventas/configuracion/ConfiguracionesIIBB.jsx";
// comparador de tablas
import ComparaTablas from "./components/comparatablas/ComparaTablas.js";

// NETIZAR ESTADISTICAS NUEVAS ENVASADO
import SucursalesNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/SucursalesHipergas";
import RankingFacturasNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/rankingFacturas/RankingFacturas";
import VerFacturaNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/verFactura/VerFactura";
import MovilesSucursalNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/moviles/MovilesSucursal";
import PanelSucursalNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/panelDatos/PanelSucursal";
import ChoferesSucursalNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/choferes/ChoferesSucursal";
import RankingFacturasPropanoNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/rankingFacturas/RankingFacturasPropano";
import RankingFacturasChoferNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/choferes/facturasChofer/RankingFacturasChofer";
import RankingChoferPropanoNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/choferes/facturasChofer/RankingChoferPropano";
import RankingFacturasMovilNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/moviles/facturasMovil/RankingFacturasMovil";
import RankingMovilPropanoNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/moviles/facturasMovil/RankingMovilPropano";
import PanelChoferNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/choferes/PanelChofer/PanelChofer";
import PanelMovilNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/moviles/PanelMovil/PanelMovil";
import FacturacionSucursalNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/facturacionSucursal/FacturacionSucursal";
import FacturacionChoferNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/choferes/facturacionChofer/FacturacionChofer";
import FacturacionMovilNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/moviles/facturacionMovil/FacturacionMovil";
import InfoGlobalNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/InfoGlobal/InfoGlobal";
import RankingVulneraNetizar from "./components/estadisticasEnvasados/statsNetizar/pantallaSucursales/rankingVulnerabilidad/RankingVulnera";
import AuditRouter from "./components/audit/AuditRouter.jsx";
import AlvearDashboard from "./components/paneles/stkFisico/dashboards/alvear/AlvearDashboard.jsx";
import PlantasIotDashboard from "./components/paneles/stkFisico/dashboards/plantasIot/PlantasIotDashboard.jsx";

import SucursalesPuntosVenta from "./components/referencias-tablas/sucursalesPuntosVenta/SucursalesPuntosVenta.js";

import Semaforo from "./components/semaforo/pages/SemaforoPage.jsx";

// LINK DE PAGO GRANEL
import LinkPagoGranel from "./components/granel/linkPago/LinkPagoGranel.js";
// LINK DE PAGO ENVASADO (cuenta corriente)
import LinkPagoEnvasado from "./components/envasados/linkPago/LinkPagoEnvasado.js";
import PedidosV2 from "./components/granel/pedidosV2/PedidosV2";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login2 />} />
        <Route path="/navbar" element={<Private Component={Navbar} />} />
        <Route
          path="/paneladmin"
          element={<Private Component={PanelAdmin} />}
        />
        <Route path="/correo" element={<Private Component={Correo2} />} />
        {/* <Route path="/configfact" element={<Private Component={ConfigFact} />} /> */}
        <Route path="/paneluser" element={<Private Component={PanelUser} />} />
        <Route path="/infousuario" element={<Private Component={InfoUser} />} />
        <Route path="/stkfisico" element={<Private Component={StkFisico} />} />
        <Route
          path="/stkfisicog"
          element={<Private Component={StkFisicoG} />}
        />
        <Route
          path="/stktotalproducto"
          element={<Private Component={StockTotal} />}
        />
        <Route
          path="/soloenvases"
          element={<Private Component={Soloenvases} />}
        />
        <Route
          path="/tanquesfijos"
          element={<Private Component={TanquesFijos} />}
        />
        {/* <Route path="/propelente/entradassalidas" element={<Private Component={Entradas_salidas} />} /> */}
        <Route
          path="/propelente/registros"
          element={<Private Component={Registros} />}
        />
        <Route
          path="/analisis_calidad"
          element={<Private Component={TablaAnalisis} />}
        />
        <Route
          path="/propelentes_metodos"
          element={<Private Component={MetodosPropelentes} />}
        />
        <Route
          path="/propelentes_componentes"
          element={<Private Component={ComponentesPropelentes} />}
        />
        <Route
          path="/componentes_productos"
          element={<Private Component={ComponentesProductos} />}
        />
        <Route
          path="/propelentes_compuestos"
          element={<Private Component={CompuestosPropelentes} />}
        />
        <Route
          path="/propelentes_productos"
          element={<Private Component={ProductosPropelentes} />}
        />
        <Route
          path="/autorizar_requerimientos"
          element={<Private Component={VistaJefeDePlanta} />}
        />
        <Route path="/ordenes" element={<Private Component={Tablistado} />} />
        {/* <Routes> */}
        <Route
          path="/autorizacion_compras"
          element={
            <FiltrosProvider>
              <Private Component={TabAutorizaciones} />
            </FiltrosProvider>
          }
        />
        {/* </Routes> */}
        <Route
          path="/autorizantes_compras"
          element={<Private Component={AutorizantesTabla} />}
        />
        {/* <Route
          path="/factibilidades2"
          element={<Private Component={Factibilidades2} />}
        /> */}
        {/* <Route path="/pedidos" element={< Private Component={Pedidos} />} /> */}
        <Route
          path="/requerimientos"
          element={<Private Component={Requerimientos_materiales} />}
        />
        <Route
          path="/certificaciones"
          element={<Private Component={Certificaciones} />}
        />
        <Route path="/choferes" element={<Private Component={Choferes} />} />
        <Route
          path="/comerciales"
          element={<Private Component={Comerciales} />}
        />
        <Route path="/contratos" element={<Private Component={Contratos} />} />
        <Route
          path="/gestiones"
          element={<Private Component={TabGestiones} />}
        />
        <Route
          path="/localidades"
          element={<Private Component={Localidades} />}
        />
        <Route path="/repartos" element={<Private Component={Repartos} />} />
        {/* GRUAS */}
        <Route
          path="/repartos_gruas"
          element={<Private Component={RepartosGruas} />}
        />
        <Route
          path="/certificadoras"
          element={<Private Component={Certificadoras} />}
        />
        <Route
          path="/direcciones"
          element={<Private Component={Direcciones} />}
        />
        <Route
          path="/fabricantes"
          element={<Private Component={Fabricantes} />}
        />
        <Route path="/rutas" element={<Private Component={Rutas} />} />
        <Route path="/segmentos" element={<Private Component={Segmentos} />} />
        <Route
          path="/subsegmentos"
          element={<Private Component={Subsegmentos} />}
        />
        <Route
          path="/supervisores"
          element={<Private Component={Supervisores} />}
        />
        <Route path="/vehiculos" element={<Private Component={Vehiculos} />} />
        <Route path="/clientes" element={<Private Component={Clientes} />} />
        <Route path="/tanques" element={<Private Component={Tanques} />} />
        <Route
          path="/ingreso-remitos"
          element={<Private Component={AddRemitos} />}
        />
        <Route
          path="/ensayo_items"
          element={<Private Component={EnsayoItems} />}
        />
        <Route path="/ctactes" element={<Private Component={ApiCoboltest} />} />
        {/* <Route path="/fomulariofactibilidades/:accion" element={< Private Component={FormularioFactibilidades} />} /> */}
        <Route
          path="/listado_proveedores"
          element={<Private Component={Listado} />}
        />
        <Route
          path="/habilitar_proveedores"
          element={<Private Component={Listados_pendientes} />}
        />
        <Route
          path="/alta_proveedores"
          element={<Private Component={AltaProveedores} />}
        />
        <Route
          path="/edicion_correos"
          element={<Private Component={CorreosAltaProveedores} />}
        />
        <Route
          path="/proveedores/nuevo_pequeño_proveedor"
          element={<Private Component={AddPeqProveedor} />}
        />
        <Route
          path="/proveedores/padron_contribuyentes"
          element={<Private Component={CargaPadronContribuyentes} />}
        />
        <Route
          path="/pago_proveedores"
          element={<Private Component={PagoProveedores} />}
        />
        <Route
          path="/importar_arca"
          element={<Private Component={FlujoImportacionArca} />}
        />
        <Route
          path="/pago_proveedores/orden"
          element={<Private Component={OrdenPagoProveedor} />}
        />
        <Route
          path="/ordenes_pago_proveedores"
          element={<Private Component={ListadoOrdenesPago} />}
        />
        <Route
          path="/ordenes_pago_proveedores/:id/editar"
          element={<Private Component={EditarOrdenPagoPendiente} />}
        />
        <Route
          path="/ordenes_pago_proveedores/:id"
          element={<Private Component={DetalleOrdenPago} />}
        />
        <Route
          path="/lotes_orden_pago"
          element={<Navigate to="/ordenes_pago_proveedores" replace />}
        />
        <Route
          path="/lotes_orden_pago/:id"
          element={<Private Component={DetalleLoteOrdenPago} />}
        />
        <Route
          path="/cheques_fisicos"
          element={<Private Component={ListadoChequesFisicos} />}
        />
        <Route
          path="/cheques_fisicos_cc"
          element={<Navigate to="/cheques_fisicos" replace />}
        />
        <Route
          path="/echeq"
          element={<Private Component={PaginaEcheq} />}
        />
        <Route
          path="/cheques_proveedores"
          element={<Navigate to="/echeq?vista=cheques&bandeja=cartera" replace />}
        />
        <Route
          path="/cheques_cc"
          element={<Navigate to="/echeq?vista=cheques&bandeja=cc" replace />}
        />
        <Route
          path="/cheques_finanzas"
          element={<Navigate to="/echeq?vista=cheques&bandeja=finanzas" replace />}
        />
        <Route
          path="/cheques_rechazos_finanzas"
          element={<Navigate to="/echeq?vista=rechazos&bandeja=finanzas" replace />}
        />
        <Route
          path="/cheques_rechazos_pagos"
          element={<Navigate to="/echeq?vista=rechazos&bandeja=pagos" replace />}
        />
        <Route
          path="/cheques_rechazos_jefe"
          element={<Navigate to="/echeq?vista=rechazos&bandeja=jefe" replace />}
        />
        <Route
          path="/cheques_rechazos_cc"
          element={<Navigate to="/echeq?vista=rechazos&bandeja=cc" replace />}
        />
        <Route
          path="/cheques_lista_negra"
          element={<Private Component={ListadoListaNegra} />}
        />
        <Route
          path="/pagos_no_proveedor"
          element={<Private Component={PagosNoProveedorPage} />}
        />
        {/* <Route
          path="/proveedores/:idProveedor/editar"
          // element={<Private Component={ProveedoresForm} />}
        /> */}
        {/* <Route
          path="/proveedores/:idProveedor/ver"
          // element={<Private Component={VerProveedor} />}
        />
        <Route
          // path="/proveedores/:idProveedor/documentos"
          element={<Private Component={Documentacion} />}
        />
        <Route
          path="/proveedores/:idProveedor/condicion_iibb"
          element={<Private Component={CondicionIIBB} />}
        />
        <Route
          path="/proveedores/:idProveedor/imputaciones"
          element={<Private Component={ImputacionesIndex} />}
        /> */}
        {/* <Route path="/afip" element={<Private Component={Archivo_Afip} />} /> */}
        <Route
          path="/gestionusuarios"
          element={<Private Component={GestionUsuarios} />}
        />
        {/* <Route path="/pedi2" element={< Private Component={PedidosTabs} />} /> */}
        {/* prueba aqui abajo */}
        {/* <Route path="/factibilidadesnew" element={<Private Component={FactibilidadesTable}/>}/> */}
        <Route
          path="/factibilidades"
          element={<Private Component={FactibilidadesTable} />}
        />
        <Route
          path="/factibilidades/aprobarconfig"
          element={<Private Component={AprobarConfig} />}
        />
        <Route path="/maptests" element={<Private Component={MapTests} />} />
        <Route
          path="/rendiciones"
          element={<Private Component={Rendiciones} />}
        />
        {/* Mio */}
        <Route path="/pedidos" element={<Private Component={PedidosTabs} />} />
        <Route
          path="/comprobantes"
          element={<Private Component={Comprobantes} />}
        />
        <Route
          path="/pedidosafacturar"
          element={<Private Component={PedidosFacturas} />}
        />
        {/* Romaneo */}
        <Route
          path="/romaneo_fabricantes"
          element={<Private Component={Romaneo_fabricantes} />}
        />
        <Route
          path="/romaneo_tipos_envases"
          element={<Private Component={Romaneo_tipos_envases} />}
        />
        <Route
          path="/romaneo_pertenencias"
          element={<Private Component={Romaneo_pertenecias} />}
        />
        <Route
          path="/romaneo_reparaciones"
          element={<Private Component={Romaneo_reparaciones} />}
        />
        <Route
          path="/romaneo_motivos"
          element={<Private Component={Romaneo_motivos} />}
        />
        <Route
          path="/romaneo_envases_tab"
          element={<Private Component={Romaneo_envases_tab} />}
        />
        <Route
          path="/romaneo_firmas"
          element={<Private Component={Romaneo_firmas} />}
        />
        {/* Mobile */}
        <Route
          path="/romaneo_M_envases_carga"
          element={<Private Component={Romaneo_M_envases_carga} />}
        />
        {/* Stock */}
        <Route
          path="/familias_lista"
          element={<Private Component={Familias_lista} />}
        />
        <Route
          path="/articulos_cargas/:id_familia"
          element={<Private Component={Articulos_cargas} />}
        />
        <Route
          path="/almacenes_cargas/:id_almacen"
          element={<Private Component={Almacenes_cargas} />}
        />
        <Route
          path="/sucursales_cargas"
          element={<Private Component={Sucursales_cargas} />}
        />
        <Route
          path="/motivos_salida"
          element={<Private Component={Motivos_salida} />}
        />
        <Route
          path="/lista_articulos/:id"
          element={<Private Component={Lista_articulos} />}
        />
        <Route
          path="/articulos_salidas/:id"
          element={<Private Component={Articulos_salidas} />}
        />
        <Route
          path="/articulos_autorizados"
          element={<Private Component={Articulos_autorizados} />}
        />
        <Route
          path="/articulos_autorizacion_transf"
          element={<Private Component={Articulos_autorizacion_transf} />}
        />
        <Route
          path="/stock_por_sucursales"
          element={<Private Component={Stock_por_sucursales} />}
        />
        <Route
          path="/autorizar_modificaciones"
          element={<Private Component={Autorizar_modificaciones} />}
        />
        <Route
          path="/rrhh_stock/:id"
          element={<Private Component={Rrhh_stock} />}
        />
        <Route
          path="/historial_fichas/:id"
          element={<Private Component={Historial_fichas} />}
        />
        <Route
          path="/automotores_stock/:id"
          element={<Private Component={Automotores_stock} />}
        />
        <Route
          path="/inventario_vehiculo"
          element={<Private Component={Inventario_vehiculo} />}
        />
        <Route
          path="/historialvehiculo"
          element={<Private Component={HistorialVehiculo} />}
        />
        <Route
          path="/inventario_conjunto"
          element={<Private Component={Inventario_conjunto} />}
        />
        <Route
          path="/stock_seguimiento"
          element={<Private Component={Seguimiento} />}
        />
        <Route
          path="/posiciones_neumaticos"
          element={<Private Component={PosicionesNeumaticos} />}
        />
        <Route
          path="/prendas_rrhh"
          element={<Private Component={Prendas_rrhh} />}
        />
        <Route
          path="/talles_prendas"
          element={<Private Component={Talles_prendas} />}
        />
        <Route
          path="/stock_empleados"
          element={<Private Component={Stock_empleados} />}
        />
        {/* TRACTORES TANQUES JAULAS ETC. */}
        {/* <Route
          path="/vehiculostanques"
          element={<Private Component={VehiculosTanques} />}
        />        */}
        {/* Auditorias */}
        <Route
          path="/auditorias"
          element={<Private Component={Auditorias} />}
        />
        <Route
          path="/auditorias/delegar/aceptado"
          element={<Private Component={Email_delegar_aceptar} />}
        />
        <Route
          path="/auditorias/delegar/rechazado"
          element={<Private Component={Email_delegar_rechazar} />}
        />
        <Route path="/sectores" element={<Private Component={Sectores} />} />
        {/* GESTIÓN SECTOR ENVASADO */}
        <Route
          path="/gestionenvasado"
          element={<Private Component={PanelDeControl} />}
        />
        {/* RECLAMOS */}
        <Route
          path="/tab_reclamos"
          element={<Private Component={TabReclamos} />}
        />
        <Route
          path="/motivos_emergencia"
          element={<Private Component={Motivos_emergencia} />}
        />
        <Route
          path="/bancos_cuentas"
          element={<Private Component={Bancos} />}
        />
        <Route
          path="/reclamos_config"
          element={<Private Component={Reclamos_config} />}
        />
        <Route
          path="/estadisticas_reclamos"
          element={<Private Component={Estadisticas_reclamos} />}
        />
        <Route
          path="/estadisticas_instalacion"
          element={<Private Component={Estadisticas_instalacion} />}
        />
        <Route
          path="/estadisticas_desconexion"
          element={<Private Component={Estadisticas_desconexion} />}
        />
        <Route
          path="/tab_instalaciones"
          element={<Private Component={Tab_instalaciones} />}
        />
        <Route
          path="/tab_desconexiones"
          element={<Private Component={Tab_desconexiones} />}
        />
        <Route
          path="/estadisticas_reemplazo"
          element={<Private Component={Estadisticas_reemplazo} />}
        />
        {/* GESTION CREDITICIA */}
        <Route
          path="/gestionCrediticia"
          element={<Private Component={GestionCrediticia} />}
        />
        {/* SOLICITUDES ABASTECIMIENTO */}
        <Route
          path="/solicitudes_abastecimiento"
          element={<Private Component={SolicitudSucursal} />}
        />
        <Route
          path="/tablaResumen"
          element={<Private Component={MatrizDobleEntrada} />}
        />
        <Route
          path="/pedidos_proveedores"
          element={<Private Component={PedidosProveedores} />}
        />
        <Route
          path="/proveedores_abastecimiento"
          element={<Private Component={Proveedores_abastecimiento} />}
        />
        <Route
          path="/viajes_abastecimiento"
          element={<Private Component={Viajes_abastecimiento} />}
        />
        <Route
          path="/sucursal_viajes"
          element={<Private Component={Sucursal_viajes} />}
        />
        <Route
          path="/viaje_arrastrable"
          element={<Private Component={Viaje_arrastrable} />}
        />
        {/* REGULADORES */}
        <Route
          path="/reguladores"
          element={<Private Component={Reguladores} />}
        />
        {/*Mapas de ventas envasado*/}
        <Route
          path="/mapaventasenvasado"
          element={<Private Component={MapaVentasEnvasado} />}
        />
        <Route
          path="/mapaventasenvasadonuevo"
          element={<Private Component={MapaVentasEnvasadoNuevo} />}
        />
        <Route path="/viandas" element={<Private Component={AltaViandas} />} />
        <Route
          path="/seleccionviandas"
          element={<Private Component={SeleccionViandas} />}
        />
        <Route
          path="/viandas/resumen"
          element={<Private Component={Resumen} />}
        />
        <Route
          path="/viandas/resumenxemplado"
          element={<Private Component={FormResumenXEmpleado} />}
        />
        <Route
          path="/viandas/viandasxfecha"
          element={<Private Component={FormResumenXFecha} />}
        />
        <Route
          path="/transportistas"
          element={<Private Component={Transportistas} />}
        />
        <Route
          path="/viandas/semanapedidos"
          element={<Private Component={SemanaPedidos} />}
        />
        <Route
          path="/viandas/seleccionexcepcional"
          element={<Private Component={SeleccionExcepcional} />}
        />
        <Route
          path="/viandas/nuevopedido"
          element={<Private Component={NuevoPedido} />}
        />
        {/* Evaluacion Comerciales */}
        <Route
          path="/evaluacionComercial"
          element={<Private Component={Eleccion_sucursal} />}
        />
        <Route
          path="/objetivosComerciales"
          element={<Private Component={Objetivos} />}
        />
        <Route
          path="/itemsComerciales"
          element={<Private Component={Items_comerciales} />}
        />
        <Route
          path="/panel_resultados"
          element={<Private Component={Panelrrhh} />}
        />
        <Route
          path="/config_evaluacion"
          element={<Private Component={Config_evaluacion} />}
        />
        <Route
          path="/checklist_rrhh"
          element={<Private Component={CheckList_rrhh} />}
        />
        <Route path="/checklist" element={<Private Component={CheckList} />} />
        <Route
          path="/resultados_checklist"
          element={<Private Component={Resultados_checklist} />}
        />
        <Route
          path="/tabla_check"
          element={<Private Component={Tabla_check} />}
        />
        <Route
          path="/tab_checklist"
          element={<Private Component={Tab_checklistResultados} />}
        />
        <Route
          path="/estadisticaCheck"
          element={<Private Component={EstadisticaCheck} />}
        />
        <Route
          path="/vehiculosInactividad"
          element={<Private Component={VehiculosInactividad} />}
        />
        <Route
          path="/resumenVehiculos"
          element={<Private Component={ResumenVehiculos} />}
        />
        <Route path="/agregamonto" element={<Private Component={Montos} />} />
        {/* semana pedidos netizar */}
        <Route
          path="/viandas/semanapedidosnetizar"
          element={<Private Component={SemanaPedidosNetizar} />}
        />
        {/*Orden de Pago*/}
        <Route
          path="/facturas"
          element={<Private Component={TablaFacturas} />}
        />
        <Route
          path="/banco/facturas"
          element={<Private Component={IngresoFacturasBanco} />}
        />
        {/*Punto de venta*/}
        <Route
          path="/puntoVenta"
          element={<Private Component={Punto_venta} />}
        />
        {/*Lista precios*/}
        <Route
          path="/lista_precios"
          element={<Private Component={Lista_precios} />}
        />
        <Route
          path="/ver_lista_precios"
          element={<Private Component={Lista_preciosConsulta} />}
        />
        <Route
          path="/precios_especiales"
          element={<Private Component={Lista_preciosEspeciales} />}
        />
        <Route
          path="/ver_precios_especiales"
          element={<Private Component={Lista_preciosEspeciales} />}
        />
        <Route path="/padrones" element={<Private Component={Padrones} />} />
        {/* VEHICULOS */}
        <Route path="/marcas" element={<Private Component={Marcas} />} />
        {/* Mqtt Test */}
        <Route path="/mqtttest" element={<Private Component={MqttTest} />} />
        {/*Panel de control Granel */}
        <Route
          path="/panelgranel"
          element={<Private Component={PanelControlGranel} />}
        />
        {/*RRHH cumpleaños */}
        <Route
          path="/rrhh_cumpleanios"
          element={<Private Component={Rrhh_cumpleanios} />}
        />
        <Route path="/productos" element={<Private Component={Productos} />} />
        {/*TANQUE REHABILITACION - TANQUES MOVILES */}
        <Route
          path="/tanque_rehabilitacion"
          element={<Private Component={Tanque_rehab} />}
        />
        <Route
          path="/vencimientosTanques"
          element={<Private Component={VencimientosTanques} />}
        />
        <Route
          path="/tanque_grupos"
          element={<Private Component={Tanque_grupos} />}
        />
        <Route
          path="/tabla_pertenencias"
          element={<Private Component={TablaPertenencias} />}
        />
        <Route
          path="/tanque_proveedor"
          element={<Private Component={Tanque_proveedor} />}
        />
        <Route
          path="/listar_repartos"
          element={<Private Component={RepartosFinalizados} />}
        />
        <Route
          path="/impuestos/montos_minimos_percepcion"
          element={<Private Component={MontosMinimosTable} />}
        />
        <Route
          path="/impuestos/listado_exenciones"
          element={<Private Component={ExencionesList} />}
        />

        {/*CHECKLIST SEGURIDAD E HIGIENE */}
        <Route
          path="/configuracion_checklist"
          element={<Private Component={Checklist_seg_hig} />}
        />
        <Route
          path="/checklist_seg_hig"
          element={<Private Component={ChecklistHS} />}
        />
        <Route
          path="/panelControl"
          element={<Private Component={PanelControl} />}
        />
        <Route
          path="/tablaChecklistSH"
          element={<Private Component={TablaChecklistSH} />}
        />
        <Route
          path="/repartos/sucursal"
          element={<Private Component={ListaRepartosSucursal} />}
        />
        <Route
          path="/listar_facturas"
          element={<Private Component={ListaFacturasSucursal} />}
        />
        <Route
          path="/correos_fallidos"
          element={<Private Component={CorreosFallidos} />}
        />
        {/* <Route
          path="/facturacion_especial"
          element={<Private Component={FacturacionRemitos} />}
        /> */}
        {/* Envasados */}
        <Route
          path="/clientesenvasados"
          element={
            <FechaProviderPedidos>
              <Private Component={ClientesEnvasado} />
            </FechaProviderPedidos>
          }
        />
        {/* <Route
          path="/pedidosenvasados"
          element={
            <FechaProviderPedidos>
              <Private Component={TabPedidos} />
            </FechaProviderPedidos>
          }
        /> */}
        <Route
          path="/pedidosenvasados"
          element={
            <FechaProviderPedidos>
              <Private Component={VistaPedidosEnvasado} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/productosenvasados"
          element={<Private Component={ProductoEnvasado} />}
        />
        <Route path="/geozonas" element={<Private Component={GeoZonas} />} />
        <Route
          path="/gruposgeograficos"
          element={<Private Component={GruposGeograficos} />}
        />
        <Route
          path="/lista_precios_envasado"
          element={<Private Component={TablaLista} />}
        />
        <Route
          path="/rendicionesenvasados"
          element={
            <FechaProviderPedidos>
              <Private Component={Rendiciones_envasados} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/historialenvasado"
          element={
            <FechaProviderPedidos>
              <Private Component={HistorialFacturados} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/todospedidos"
          element={
            <FechaProviderPedidos>
              <Private Component={TodosPedidos} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/verfacturaenvasado"
          element={<Private Component={VerFacturaEnvasado} />}
        />
        <Route
          path="/mapapedidosenvasado"
          element={
            <FechaProviderPedidos>
              <Private Component={MapaPedidos} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/rangoprecios"
          element={<Private Component={TablaRangoPrecios} />}
        />
        <Route
          path="/rangocategorias"
          element={<Private Component={PreciosCategorias} />}
        />
        <Route
          path="/envasadohojaruta"
          element={<Private Component={HojaDeRuta} />}
        />
        <Route
          path="/envasadoclientesruta"
          element={<Private Component={ClientesRuta} />}
        />
        <Route
          path="/envasadomotivosnocompra"
          element={<Private Component={MotivosNoCompra} />}
        />
        <Route
          path="/envasadopredeterminadossisven"
          element={<Private Component={PredeterminadosSisven} />}
        />
        <Route
          path="/envasadousos"
          element={<Private Component={UsosEnvasado} />}
        />
        <Route
          path="/envasadotiposclientes"
          element={<Private Component={TiposClientesEnvasado} />}
        />
        <Route
          path="/listapreciosespeciales"
          element={<Private Component={ListaPreciosEspeciales} />}
        />
        <Route
          path="/envasadomotivosrechazo"
          element={<Private Component={MotivosRechazo} />}
        />
        <Route
          path="/envasadoentregaremito"
          element={<Private Component={EntregaConRemito} />}
        />
        <Route
          path="/envasadoclientesasociados"
          element={<Private Component={ClientesAsociados} />}
        />
        <Route
          path="/envasadoresumenentregas"
          element={<Private Component={PanelResumenRemitos} />}
        />
        <Route
          path="/envasadotalonarios"
          element={<Private Component={EnvasadoTalonarios} />}
        />
        <Route
          path="/envasadocsvqr"
          element={
            <FechaProviderPedidos>
              <Private Component={CsvQR} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/envasadosucextendidas"
          element={<Private Component={SucursalesHabilitadas} />}
        />
        <Route
          path="/pedidosstandby"
          element={
            <FechaProviderPedidos>
              <Private Component={PedidosStandBy} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/sucursalesmercadolibre"
          element={<Private Component={SucursalesMercadoLibre} />}
        />
        <Route
          path="/resumensucursal"
          element={
            <FechaProviderPedidos>
              <Private Component={ResumenSucursal} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/resumencuentacorriente"
          element={
            <FechaProviderPedidos>
              <Private Component={ResumenCuentaCorriente} />
            </FechaProviderPedidos>
          }
        />
        <Route
          path="/filtrarmedios"
          element={
            <Private Component={FiltrarMedios} />
          }
        />
        <Route
          path="/terminales"
          element={
            <Private Component={Terminales} />
          }
        />
        <Route
          path="/posnetschoferes"
          element={
            <Private Component={PosnetsChoferes} />
          }
        />
        <Route path="/CSVlistadoclientes" element={<ListadoClientes />} />

        <Route
          path="/pagosenvasados"
          element={<Private Component={PagosEnsadoReporte} />}
        />

        <Route
          path="/envasadoremitosfacturados"
          element={<Private Component={RemitosFacturados} />}
        />
        <Route
          path="/envasadosubidacomprobantes"
          element={<Private Component={SubidaArchivoSimple} />}
        />
        {/* sucursalesCRUD */}
        <Route
          path="/sucursalesCRUD"
          element={<Private Component={Sucursales} />}
        />
        {/*Facturas Parametros*/}
        <Route
          path="/facturasParametros"
          element={<Private Component={Facturas} />}
        />
        {/*Mant Plantas*/}
        <Route
          path="/mant_plantas"
          element={<Private Component={MantenimientoWrapper} />}
        />
        <Route
          path="/mant_plantas/equipos/:id/documentacion"
          element={<Private Component={EquipmentDocumentationContainer} />}
        />
        <Route
          path="/mant_plantas/matafuegos"
          element={<Private Component={MatafuegosIndex} />}
        />
        <Route
          path="suscripciones"
          element={<Private Component={TablaSuscripciones} />}
        />
        {/* Revision Vehiculos */}
        <Route
          path="/revision_vehiculos"
          element={<Private Component={VehiculosRevision} />}
        />
        <Route
          path="/tareas_tipo_vehiculos"
          element={<Private Component={TareasTipoVehiculos} />}
        />
        <Route
          path="frecuencia_kilometros"
          element={<Private Component={FrecuenciaKilometros} />}
        />
        <Route
          path="patentes_observaciones"
          element={<Private Component={PatentesObservaciones} />}
        />
        <Route
          path="panel_mantenimiento"
          element={<Private Component={PanelMantenimiento} />}
        />
        {/* Tipo Vehiculos */}
        <Route
          path="tipos_vehiculos"
          element={<Private Component={TiposVehiculos} />}
        />
        {/* stock de reguladores */}
        <Route
          path="/tab_reguladores"
          element={<Private Component={Tab_reguladores} />}
        />
        <Route
          path="/tab_reguladores"
          element={<Private Component={Reguladores_abm} />}
        />
        <Route
          path="/reguladores_caudal"
          element={<Private Component={Reguladores_caudal} />}
        />
        <Route
          path="/reguladores_presion_eys"
          element={<Private Component={Reguladores_presion_eys} />}
        />
        <Route
          path="/reguladores_marcas"
          element={<Private Component={Reguladores_marcas} />}
        />
        {/* Telemetria tanques de granel */}
        <Route path="/telemetry" element={<Private Component={Telemetria} />} />
        <Route
          path="/sp_solicitudes"
          element={<Private Component={sp_solicitudes} />}
        />
        <Route
          path="/sp_puestos"
          element={<Private Component={sp_puestos} />}
        />
        {/* *************** Estadisticas Envasados (Nico) ***************** */}
        <Route
          path="/datosenvasados"
          element={<Private Component={DatosSucursal} />}
        />
        <Route
          path="/detalledatos"
          element={<Private Component={DetalleDatos} />}
        />
        <Route
          path="/listachoferes"
          element={<Private Component={ListaChoferes} />}
        />
        <Route
          path="/listamoviles"
          element={<Private Component={ListaMoviles} />}
        />
        <Route
          path="/datosmoviles"
          element={<Private Component={DatosMoviles} />}
        />
        <Route
          path="/datoschoferes"
          element={<Private Component={DatosChoferes} />}
        />
        <Route
          path="/evaluaciones_medicas"
          element={<Private Component={EvaluacionById} />}
        />
        <Route path="/SP_mails" element={<Private Component={sp_mails} />} />
        <Route
          path="/SP_motivos"
          element={<Private Component={sp_motivos} />}
        />
        <Route
          path="/SP_motivos_desplegables"
          element={<Private Component={sp_motivos_desplegables} />}
        />
        <Route
          path="/SP_proximas_entrevistas"
          element={<Private Component={SpProximasEntrevistas} />}
        />
        {/* estadistica de envasados aogas */}
        <Route
          path="/datosenvasadosaogas"
          element={
            <FechaProvider>
              <Private Component={DatosSucursalAogas} />
            </FechaProvider>
          }
        />
        <Route
          path="/detalledatosaogas"
          element={
            <FechaProvider>
              <Private Component={DetalleDatosAogas} />
            </FechaProvider>
          }
        />
        <Route
          path="/listachoferesaogas"
          element={
            <FechaProvider>
              <Private Component={ListaChoferesAogas} />
            </FechaProvider>
          }
        />
        <Route
          path="/listamovilesaogas"
          element={
            <FechaProvider>
              <Private Component={ListaMovilesAogas} />
            </FechaProvider>
          }
        />
        <Route
          path="/datosmovilesaogas"
          element={
            <FechaProvider>
              <Private Component={DatosMovilesAogas} />
            </FechaProvider>
          }
        />
        <Route
          path="/datoschoferesaogas"
          element={
            <FechaProvider>
              <Private Component={DatosChoferesAogas} />
            </FechaProvider>
          }
        />
        <Route
          path="/sucursaleshipergas"
          element={
            <FechaProvider>
              <Private Component={SucursalesHipergas} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturas"
          element={
            <FechaProvider>
              <Private Component={RankingFacturas} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturaspropano"
          element={
            <FechaProvider>
              <Private Component={RankingFacturasPropano} />
            </FechaProvider>
          }
        />
        <Route
          path="/verfactura"
          element={
            <FechaProvider>
              <Private Component={VerFactura} />
            </FechaProvider>
          }
        />
        <Route
          path="/movileshipergas"
          element={
            <FechaProvider>
              <Private Component={MovilesSucursal} />
            </FechaProvider>
          }
        />
        <Route
          path="/panelsucursal"
          element={
            <FechaProvider>
              <Private Component={PanelSucursal} />
            </FechaProvider>
          }
        />
        <Route
          path="/chofereshipergas"
          element={
            <FechaProvider>
              <Private Component={ChoferesSucursal} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturaschofer"
          element={
            <FechaProvider>
              <Private Component={RankingFacturasChofer} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingchoferpropano"
          element={
            <FechaProvider>
              <Private Component={RankingChoferPropano} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturasmovil"
          element={
            <FechaProvider>
              <Private Component={RankingFacturasMovil} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingmovilpropano"
          element={
            <FechaProvider>
              <Private Component={RankingMovilPropano} />
            </FechaProvider>
          }
        />
        <Route
          path="/panelchofer"
          element={
            <FechaProvider>
              <Private Component={PanelChofer} />
            </FechaProvider>
          }
        />
        <Route
          path="/panelmovil"
          element={
            <FechaProvider>
              <Private Component={PanelMovil} />
            </FechaProvider>
          }
        />
        <Route
          path="/facturacionsucursal"
          element={
            <FechaProvider>
              <Private Component={FacturacionSucursal} />
            </FechaProvider>
          }
        />
        <Route
          path="/facturacionchofer"
          element={
            <FechaProvider>
              <Private Component={FacturacionChofer} />
            </FechaProvider>
          }
        />
        <Route
          path="/facturacionmovil"
          element={
            <FechaProvider>
              <Private Component={FacturacionMovil} />
            </FechaProvider>
          }
        />
        <Route
          path="/infoglobal"
          element={
            <FechaProvider>
              <Private Component={InfoGlobal} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingvulnerabilidad"
          element={
            <FechaProvider>
              <Private Component={RankingVulnera} />
            </FechaProvider>
          }
        />
        <Route
          path="/aprobarcambiotitularidad/:id_cliente_nuevo"
          element={<Private Component={AprobacionCambioTitularidad} />}
        />
        <Route
          path="/clientes/profile/:id/:tab"
          element={<Private Component={FichaCliente} />}
        />
        {/*viandas2*/}
        <Route
          path="/viandas/cargarmenu"
          element={<Private Component={Cargarmenu} />}
        />
        <Route
          path="/viandas/selecionarMenuEnLaMismaSemana"
          element={<Private Component={SeleccionarViandasEnLaMismaSemana} />}
        />
        <Route
          path="/viandas/selecionarmenu"
          element={<Private Component={Selectviandas} />}
        />
        <Route
          path="/viandas/selecionarMenuEnLaMismaSemana"
          element={<Private Component={SeleccionarViandasEnLaMismaSemana} />}
        />
        <Route
          path="/viandas/resumenporempleado"
          element={<Private Component={Resumenxempleado} />}
        />
        <Route
          path="/viandas/generarCSV"
          element={<Private Component={GenerarExcel} />}
        />
        <Route
          path="/viandas/imprimiretiquetas"
          element={<Private Component={Etiquetas} />}
        />
        <Route
          path="/viandas/Reporte"
          element={<Private Component={Reporte} />}
        />
        <Route
          path="/viandas/confirmacion"
          element={<Private Component={OrderConfirmationScreen} />}
        />
        <Route
          path="/viandas/sinPedir"
          element={<Private Component={UsersSinPedir} />}
        />
        {/*viandas v2 - API /api/viandas2*/}
        <Route
          path="/viandasv2/mis-viandas"
          element={<Private Component={MisViandasPage} />}
        />
        <Route
          path="/viandasv2/rrhh"
          element={<Private Component={ViandasRRHHPage} />}
        />
        {/* Reporte combustible de vehículos */}
        <Route
          path="/reporte_combustibles"
          element={<Private Component={ReporteCombustibles} />}
        />
        <Route
          path="/proveedores_combustible"
          element={<Private Component={ProveedoresCombustible} />}
        />
        <Route
          path="/productos_reporte"
          element={<Private Component={ProductosReporte} />}
        />
        <Route
          path="/anomalias_reporte_combustibles"
          element={<Private Component={AnomaliasReportes} />}
        />
        {/* ventas */}
        <Route
          path="/ventas/facturacion"
          element={<Private Component={PantallaGeneral} />}
        />
        <Route
          path="/RRHH/resumendeviandas"
          element={<Private Component={TablaPedidoSemana} />}
        />
        {/* Scada propelentes */}
        <Route
          path="/scada/propelentes"
          element={<Private Component={Scada} />}
        />
        {/* <Route
          path="/viandas/cargarmenu/invitados"
          element={<Private Component={Selecinvitado} />}
        /> */}
        <Route
          path="/periodo_contable"
          element={<Private Component={Periodos} />}
        />
        <Route
          path="/buscadorfacturas"
          element={<Private Component={Buscadorfacturas} />}
        />
        {/* Expo empleos */}
        <Route
          path="/expoEmpleos/"
          element={<Private Component={ApplicantsView} />}
        />
        {/* Estadistica recuento fisico */}
        <Route
          path="/estadisticaStockEnvases"
          element={<Private Component={EstadisticaStockEnvases} />}
        />
        <Route path="/verlogs" element={<Private Component={Evepanelctrl} />} />
        {/* Validar el acceso a planta de choferes-tanques-camiones */}
        <Route
          path="/accesoPlanta"
          element={<Private Component={accesoPlanta} />}
        />
        <Route
          path="/requerimientos_rechazados"
          element={<Private Component={Requerimientos_rechazados} />}
        />
        <Route
          path="/vacaciones"
          element={<Private Component={vacaciones} />}
        />
        <Route
          path="/vacacionesRechazadas"
          element={<Private Component={vacacionesRechazadas} />}
        />
        <Route
          path="/choferes/nuevo"
          element={<Private Component={Addchofer} />}
        />
        <Route
          path="/historialOrdenes"
          element={<Private Component={Historial} />}
        />
        <Route
          path="/wa_menus"
          element={<Private Component={WaMenusWithSnacks} />}
        />
        <Route
          path="/wa_tareas"
          element={<Private Component={WaTareasList} />}
        />
        <Route
          path="/controlhorario"
          element={<Private Component={PanelSucursales} />}
        />
        {/* RRHH - Legajos de Empleados */}
        <Route
          path="/rrhh2/legajos"
          element={<Private Component={EmpleadosPage} />}
        />
        <Route
          path="/rrhh2/legajos/formulariov2"
          element={<Private Component={LegajosWrapper} />}
        />
        <Route
          path="/rrhh2/legajos/creado"
          element={<Private Component={CreatedSuccessPage} />}
        />
        <Route
          path="/rrhh2/convenios"
          element={<Private Component={ConveniosPage} />}
        />
        <Route
          path="/rrhh2/categorias"
          element={<Private Component={CategoriasPage} />}
        />
        <Route
          path="/rrhh2/tareas"
          element={<Private Component={TareasPage} />}
        />
        <Route
          path="/rrhh2/obras-sociales"
          element={<Private Component={OSPage} />}
        />
        <Route
          path="/vehiculos_componentes"
          element={<Private Component={ComponentesVehiculos} />}
        />
        {/* Canje de Envases */}
        <Route
          path="/canje/registro"
          element={<Private Component={CanjeRegistro} />}
        />
        <Route
          path="/canje/resumen"
          element={<Private Component={CanjeResumen} />}
        />
        <Route
          path="/canje/resumen-empresas"
          element={<Private Component={CanjeResumenPorEmpresa} />}
        />
        <Route
          path="/autgastoscombustible"
          element={<Private Component={AutGastosCombustibleList} />}
        />
        <Route
          path="/factibilidades/form_administracion/:uuidfact"
          element={<Private Component={FactibilidadContainer} />}
        />
        <Route
          path="/recibos/pendientes"
          element={<Private Component={recibosPendientes} />}
        />

        {/* comparador de tablas */}
        <Route
          path="/comparatablas"
          element={<Private Component={ComparaTablas} />}
        />
        {/* comparador de tablas
        <Route
          path="/comparatablas"
          element={<Private Component={ComparaTablas} />}
        /> */}

        <Route
          path="/tabla-choferes"
          element={<Private Component={TablaChoferes} />}
        />
        <Route
          path="/config_iibb"
          element={<Private Component={ConfiguracionesIIBB} />}
        />
        {/* estadistica de envasados NETIZAR */}

        <Route
          path="/sucursalesnetizar"
          element={
            <FechaProvider>
              <Private Component={SucursalesNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturasnetizar"
          element={
            <FechaProvider>
              <Private Component={RankingFacturasNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturaspropanonetizar"
          element={
            <FechaProvider>
              <Private Component={RankingFacturasPropanoNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/verfacturanetizar"
          element={
            <FechaProvider>
              <Private Component={VerFacturaNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/movileshipergasnetizar"
          element={
            <FechaProvider>
              <Private Component={MovilesSucursalNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/panelsucursalnetizar"
          element={
            <FechaProvider>
              <Private Component={PanelSucursalNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/chofereshipergasnetizar"
          element={
            <FechaProvider>
              <Private Component={ChoferesSucursalNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturaschofernetizar"
          element={
            <FechaProvider>
              <Private Component={RankingFacturasChoferNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingchoferpropanonetizar"
          element={
            <FechaProvider>
              <Private Component={RankingChoferPropanoNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingfacturasmovilnetizar"
          element={
            <FechaProvider>
              <Private Component={RankingFacturasMovilNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingmovilpropanonetizar"
          element={
            <FechaProvider>
              <Private Component={RankingMovilPropanoNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/panelchofernetizar"
          element={
            <FechaProvider>
              <Private Component={PanelChoferNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/panelmovilnetizar"
          element={
            <FechaProvider>
              <Private Component={PanelMovilNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/facturacionsucursalnetizar"
          element={
            <FechaProvider>
              <Private Component={FacturacionSucursalNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/facturacionchofernetizar"
          element={
            <FechaProvider>
              <Private Component={FacturacionChoferNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/facturacionmovilnetizar"
          element={
            <FechaProvider>
              <Private Component={FacturacionMovilNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/infoglobalnetizar"
          element={
            <FechaProvider>
              <Private Component={InfoGlobalNetizar} />
            </FechaProvider>
          }
        />
        <Route
          path="/rankingvulnerabilidadnetizar"
          element={
            <FechaProvider>
              <Private Component={RankingVulneraNetizar} />
            </FechaProvider>
          }
        />

        <Route
          path="/audit_items/*"
          element={
            <>
              <Navbar />
              <AuditRouter />
            </>
          }
        />

        <Route
          path="/impuestos/libro_iva_digital"
          element={<Private Component={LibroIvaDigital} />}
        />

        <Route
          path="/impuestos/ddjj_iibb"
          element={<Private Component={ArchivoDdJjIiBb} />}
        />

        <Route
          path="/impuestos/ddjj_perciva"
          element={<Private Component={ArchivoPercIva} />}
        />

        <Route
          path="/hmi-alvear"
          element={
            <Private
              Component={() => (
                <AlvearDashboard
                  apiUrl="https://hmi.netizar.com"
                  socketUrl="https://hmi.netizar.com"
                />
              )}
            />
          }
        />

        <Route
          path="/plantas-iot"
          element={
            <Private
              Component={() => (
                <PlantasIotDashboard
                  apiUrl={process.env.REACT_APP_HMI_URL || "https://hmi.netizar.com"}
                />
              )}
            />
          }
        />

        <Route
          path="/ventas/listado-comprobantes-web"
          element={<Private Component={ContainerListadoComprobantes} />}
        />

        <Route
          path="/puntos-venta-sucursales"
          element={<Private Component={SucursalesPuntosVenta} />}
        />

        <Route path="/remitos" element={<Private Component={Remitos} />} />

        <Route
          path="/ventas/facturacion-remitos-gp"
          element={<Private Component={FacturacionRemitosList} />}
        />

        <Route path="/semaforo" element={<Private Component={Semaforo} />} />


        {/* LINK DE PAGO GRANEL */}
        <Route path="/linkpago-granel" element={<Private Component={LinkPagoGranel} />} />
        {/* LINK DE PAGO ENVASADO (cuenta corriente) */}
        <Route path="/linkpago-envasado" element={<Private Component={LinkPagoEnvasado} />} />
        <Route path="/pedidosv2" element={<Private Component={PedidosV2} />} />
      </Routes>
    </>
  );
}

export default App;
